import { types, getParent } from "mobx-state-tree"

const SearchResult = types
  .model('SearchResult', {
    title: types.string,
    image: types.string,
    urlname: types.string
  })

export const SearchStore = types
    .model("SearchStore", {
        results: types.optional(types.array(SearchResult), []),
        searchTerm: types.optional(types.string, ''),
        isFocused: types.optional(types.boolean, false)
    })
    .views(self => ({
        get shop() {
            return getParent(self)
        },
        get showResults() {
          return self.isFocused && self.searchTerm.length > 0;
        }
    }))
    .actions(self => {

        function setResults(results) {
            self.results = results;
        }

        function setSearchTerm(searchTerm) {
            self.searchTerm = searchTerm;
        }

        function setIsFocused(isFocused) {
          self.isFocused = isFocused;
        }

        return {
          setResults,
          setSearchTerm,
          setIsFocused
        }
    });